// extracted by mini-css-extract-plugin
module.exports = {"background":"HomeContent_background__3X8si"};